module.exports = __webpack_public_path__ + "img/h5_game_detail_rolling10_regular.d2fa69c3.jpg";